/**
 * Plans v2 local caps for API data: what a collections array holds. Pure (no
 * store), so the MCP write path can count `before` and `next` without
 * pulling a UI store into its import graph.
 */
export function countApiItems(collections) {
  const list = Array.isArray(collections) ? collections : [];
  return {
    collections: list.length,
    requests: list.reduce((n, c) => n + (Array.isArray(c?.requests) ? c.requests.length : 0), 0),
  };
}
